<div class="page-container">
  <!-- 头部 -->
  <div class="main-container unity-padding-web unity-padding-h5-16">
    <div class="container">
      <div class="header-container">
        <p class="title">My Bonuses</p>
      </div>
      <div class="content">
        <div class="left" #tabContainer>
          <cs-tab
            class="tab"
            [tabIcons]="tabIcons"
            [tabs]="tabs"
            [selectedIndex]="tabIndex"
            [width]="tabWidth"
            padding="sm"
            [direction]="direction"
            textAlign="left"
            #tabRefs
            fontWeight="medium"
            (tabChange)="onTabChanged($event)"
          ></cs-tab>
        </div>
        <div class="right">
          <!-- section one -->
          <div class="top-fixed-part" [appLoading]="sectionOneLoading">
            @if (!sectionOneLoading) {
              <!-- bonus wallet -->
              <div class="card">
                <div class="heading">
                  <img src="assets/images/bonuses/default.png" alt="" />
                  <div class="info">
                    <div class="tt">Bonus wallet</div>
                    <div class="desc">Unlock real cash by completing bonus wagering.</div>
                  </div>
                  @if (lockedBonusAmount > 0) {
                    <div class="btn-info" (click)="handleOpenLockedBonuses()">
                      <i class="fi-information-circle-filled"></i>
                    </div>
                  }
                </div>
                <div class="cont">
                  <div class="item">
                    <div class="label">
                      <span>Claimed</span>
                      <img class="currency-icon" [src]="'USDT' | currencyIcon" alt="" />
                    </div>
                    <div class="value">{{ totalClaimAmount | currencyValue: 'CNY' }}</div>
                  </div>
                  <div class="item">
                    <div class="label">
                      <span>Balance</span>
                      <img class="currency-icon" [src]="'USDT' | currencyIcon" alt="" />
                    </div>
                    <div class="value">{{ lockedBonusAmount | currencyValue: 'CNY' }}</div>
                  </div>
                </div>
              </div>
              <!-- profile -->
              <div class="card">
                <div class="profile">
                  <app-user-avatar [avatarImgSrc]="userInfo?.avater || ''" [size]="'large'"></app-user-avatar>
                  <div class="name">{{ userInfo?.userName || 'unknown' }}</div>
                  <img class="vip" src="assets/images/vip/vip_{{ userInfo?.viPGrade || 0 }}.png" alt="" />
                </div>
                <!-- vip進度條 -->
                <app-progress-bar></app-progress-bar>
              </div>
              <!-- cashback -->
              <div class="card">
                <div class="heading">
                  <img src="assets/images/bonuses/cashback.png" alt="" />
                  <div class="info">
                    <div class="tt">Cashback</div>
                    <div class="desc">Accumulated Cashback</div>
                  </div>
                  @if (cashbackData.amount > 0) {
                    <div class="btn-info" (click)="handleOpenCashbackRedemption()">
                      <i class="fi-information-circle-filled"></i>
                    </div>
                  }
                </div>
                <div class="bar-wrap">
                  <div class="bar-info">
                    <p>Balance</p>
                    <p class="bold">
                      {{ cashbackData.amount || 0 | currencyValue: 'CNY' }}/{{
                        cashbackData.totalCapInUsdt || 0 | currencyValue: 'CNY'
                      }}
                      USDT
                    </p>
                  </div>
                  <div class="bar">
                    <div class="bar-inner" [style.width.%]="cashbackData.percent"></div>
                  </div>
                </div>
                <cs-button
                  label="Claim to Wallet"
                  [loading]="clickClaimCashbackLoading"
                  color="accent"
                  size="default"
                  [disabled]="cashbackData.amount === 0"
                  (buttonClick)="handleClaimCashback()"
                ></cs-button>
              </div>
            }
          </div>

          <div class="bonuses-anchor" #bonusesAnchor></div>
          <!-- section two -->
          <div #BonusActive class="bonuses-wrap" [class.active]="tabIndex == 0 || tabIndex == 1">
            <div class="heading">
              <div>
                <i class="fi-check-circle-filled"></i>
                <span>Active bonuses</span>
              </div>
            </div>
            <div class="cont" [appLoading]="isActiveBonusLoading">
              @if (!isActiveBonusLoading) {
                @if (activeBonusList.length > 0) {
                  <div class="list">
                    @for (item of activeBonusList; track $index) {
                      <div class="item">
                        <div class="top-part">
                          <img src="assets/images/bonuses/{{ item.logo }}.png" alt="" />
                          <div class="info">
                            <div class="tt">{{ item.activityName }}</div>
                            <div class="desc">{{ item.activitySubName }}</div>
                          </div>
                          <div class="btn-info" (click)="handleOpenBonusRule(item, 'active')">
                            <i class="fi-information-circle-filled"></i>
                          </div>
                        </div>
                        <div class="highlight">
                          <div class="tt">
                            @switch (true) {
                              @case (
                                item.walletType === NewBonusWalletType.FreeSpin ||
                                item.walletType === NewBonusWalletType.FreeChip
                              ) {
                                Winnings
                              }
                              @default {
                                You have received
                              }
                            }
                          </div>
                          <div>
                            <div class="amount">
                              <span>{{
                                item.bonusAmount
                                  | currencyValue: 'item.currency'
                                  | replace: ',' : ''
                                  | stripTrailingZeros
                              }}</span>
                              <img class="currency-icon" [src]="item.currency | currencyIcon" alt="" />
                            </div>
                          </div>
                        </div>
                        <div class="process">
                          <div class="tt">Wager to unlock</div>
                          <div class="bar-wrap">
                            <div class="bar">
                              <div
                                class="bar-inner"
                                [style.width]="(item.turnoverAmount / item.turnoverLimit) * 100 + '%'"
                              ></div>
                            </div>
                            <div class="bar-info">
                              <p class="bold">
                                {{
                                  item.turnoverAmount
                                    | currencyValue: 'item.currency'
                                    | replace: ',' : ''
                                    | stripTrailingZeros
                                }}/{{
                                  item.turnoverLimit
                                    | currencyValue: 'item.currency'
                                    | replace: ',' : ''
                                    | stripTrailingZeros
                                }}
                                {{ item.currency }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="bonus-details">
                          @switch (true) {
                            @case (
                              item.walletType === NewBonusWalletType.FreeSpin ||
                              item.walletType === NewBonusWalletType.FreeChip
                            ) {
                              <div class="item-detail">
                                <div class="label"><span>Ends on</span></div>
                                <div class="text">
                                  {{
                                    item.isPermanent
                                      ? ('bonus_permanent_valid' | translate)
                                      : (item.deadline | mdate: 'DD/MM/YYYY HH:mm')
                                  }}
                                </div>
                              </div>
                              <div class="item-detail">
                                <div class="label"><span>Wagering requirement</span></div>
                                <div class="text">{{ item.withdrawFlowMultiple }}x</div>
                              </div>
                              @if (item.bonusToMainLimit && item.bonusToMainLimit > 0) {
                                <div class="item-detail">
                                  <div class="label"><span>Max payout cap</span></div>
                                  <div class="text">
                                    {{
                                      item.bonusToMainLimit
                                        | currencyValue: item.currency || ''
                                        | replace: ',' : ''
                                        | stripTrailingZeros
                                    }}
                                    {{ item.currency }}
                                  </div>
                                </div>
                              }
                            }
                            @default {
                              <div class="item-detail">
                                <div class="label">
                                  <span>Ends on</span>
                                </div>
                                <div class="text">
                                  {{
                                    item.isPermanent
                                      ? ('bonus_permanent_valid' | translate)
                                      : (item.deadline | mdate: 'DD/MM/YYYY HH:mm')
                                  }}
                                </div>
                              </div>
                              <div class="item-detail">
                                <div class="label"><span>Validity</span></div>
                                <div class="text">
                                  @if (!item.isPermanent) {
                                    {{ item.days }} days
                                  } @else {
                                    No Expiry
                                  }
                                </div>
                              </div>
                              <div class="item-detail">
                                <div class="label"><span>Minimum deposit</span></div>
                                <div class="text">
                                  {{
                                    item.finalMinDeposit
                                      | currencyValue: item.finalCurrency || 'USDT'
                                      | replace: ',' : ''
                                      | stripTrailingZeros
                                  }}
                                  {{ item.finalCurrency || '' }}
                                </div>
                              </div>
                            }
                          }
                        </div>
                        <cs-button
                          label="Forfeit"
                          color="primary"
                          size="default"
                          [loading]="forfeitDataLoading"
                          (buttonClick)="openForfeitPopup(item)"
                        ></cs-button>
                      </div>
                    }
                  </div>
                } @else {
                  <app-empty
                    [title]="'No active bonuses yet'"
                    [message]="'Claim one of the eligible bonuses below to activate it'"
                  ></app-empty>
                }
              }
            </div>
          </div>

          <!-- section three-->
          <div class="bonuses-wrap" [class.active]="tabIndex == 0 || tabIndex == 2">
            <div class="heading">
              <div>
                <i class="fi-eligible-bonuses"></i>
                <span>Eligible bonuses</span>
              </div>
              <cs-button
                label="Redeem Code"
                color="secondary"
                size="default"
                width="auto"
                (buttonClick)="handleOpenRedeemCode()"
              ></cs-button>
            </div>
            <div class="cont" [appLoading]="sectionThreeLoading">
              @if (!sectionThreeLoading) {
                <div class="list">
                  @for (item of eligibleBonusList; track $index) {
                    <div class="item">
                      <div class="top-part">
                        <img src="assets/images/bonuses/bonus-wallet.png" alt="" />
                        <div class="info">
                          <div class="tt">{{ item.activityName }}</div>
                          <div class="desc">{{ item.activitySubName }}</div>
                        </div>
                        <div class="btn-info" (click)="handleOpenBonusRule(item, 'eligible')">
                          <i class="fi-information-circle-filled"></i>
                        </div>
                      </div>
                      <div>
                        <div class="highlight">
                          @if (isFCFS(item.grantType)) {
                            <img class="voucher-game-logo" [src]="item.gameLogoUrl" (error)="onImgError($event)" />
                            <p class="voucher-game-name">{{ item.gameName }}</p>
                          } @else {
                            <div class="tt">{{ item.rate }}% of your deposit up to</div>
                            <div class="amount">
                              <span>{{
                                item.isMultiplePrize
                                  ? (item.finalMinBonusAmount
                                      | currencyValue: item.finalCurrency || ''
                                      | replace: ',' : ''
                                      | stripTrailingZeros) +
                                    ' - ' +
                                    (item.finalMaxBonusAmount
                                      | currencyValue: item.finalCurrency || ''
                                      | replace: ',' : ''
                                      | stripTrailingZeros)
                                  : (item.finalMaxBonusAmount
                                    | currencyValue: item.finalCurrency || ''
                                    | replace: ',' : ''
                                    | stripTrailingZeros)
                              }}</span>
                              <img class="currency-icon" [src]="item.finalCurrency | currencyIcon" alt="" />
                            </div>
                          }
                          <div class="currency-list-container">
                            @if (item.currencyList && item.currencyList.length > 1) {
                              @for (innerItem of item.currencyList.slice(0, 8); track innerItem) {
                                <img class="currency-list-icon" [src]="innerItem | currencyIcon" />
                              }
                              @if (item.currencyList.length > 8) {
                                <div class="more-icon">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </div>
                              }
                            }
                          </div>
                        </div>
                        @if (item.currencyList && item.currencyList.length > 1) {
                          <div class="note">Available in any currencies within the Terms & Conditions</div>
                        }
                      </div>
                      <div class="bonus-details">
                        @if (isFCFS(item.grantType)) {
                          <div class="item-detail">
                            <div class="label">
                              <span>Ends on</span>
                            </div>
                            <div class="text">
                              {{ item.activityPeriodEndTime | mdate: 'YYYY-MM-DD HH:mm' }}
                            </div>
                          </div>
                          @if (item.grantType === 'FreeSpin') {
                            <div class="item-detail">
                              <div class="label">
                                <span>Free spins</span>
                              </div>
                              <div class="text">{{ item.spinNum }}</div>
                            </div>
                            <div class="item-detail">
                              <div class="label">
                                <span>Spin value</span>
                              </div>
                              <div class="text">{{ item.spinValue }} {{ item.currency }}</div>
                            </div>
                          } @else {
                            <div class="item-detail">
                              <div class="label">
                                <span>Free chip worth</span>
                              </div>
                              <div class="text">{{ item.spinValue }} {{ item.currency }}</div>
                            </div>
                          }
                        } @else {
                          <div class="item-detail">
                            <div class="label">
                              <span>Ends on</span>
                            </div>
                            <div class="text">
                              {{ item.activityPeriodEndTime || item.activityEndTime | mdate: 'DD/MM/YYYY HH:mm' }}
                            </div>
                          </div>
                          <div class="item-detail">
                            <div class="label"><span>Validity</span></div>
                            <div class="text">
                              @if (item.maxValidityDays < 9999) {
                                {{ item.maxValidityDays }} Days
                              } @else {
                                No Expiry
                              }
                            </div>
                          </div>
                        }
                        <div class="item-detail">
                          <div class="label"><span>Minimum deposit</span></div>
                          <div class="text">
                            {{
                              item.finalMinDeposit
                                | currencyValue: item.finalCurrency || 'USDT'
                                | replace: ',' : ''
                                | stripTrailingZeros
                            }}
                            {{ item.finalCurrency || '' }}
                          </div>
                        </div>
                        @if (getRemainingRewardAmount(item); as remainingRewardAmount) {
                          <div class="item-detail">
                            <div class="label"><span>Left to claim</span></div>
                            <div class="text">
                              {{ remainingRewardAmount }}
                            </div>
                          </div>
                        }
                      </div>
                      <cs-button
                        (buttonClick)="handleActiveBonusWallet(item)"
                        label="Claim"
                        color="primary"
                        size="default"
                      ></cs-button>
                    </div>
                  }

                  @for (item of couponCardList; track $index) {
                    <div class="item">
                      <div class="top-part">
                        <img src="assets/images/bonuses/{{ item.logo }}.png" alt="" />
                        <div class="info">
                          <div class="tt">{{ item.title }}</div>
                          <div class="desc">{{ item.introduction || '' }}</div>
                        </div>
                        <div class="btn-info" (click)="handleOpenBonusRule(item, 'detail')">
                          <i class="fi-information-circle-filled"></i>
                        </div>
                      </div>

                      @switch (true) {
                        @case (item.grantType === 'FreeSpin' || item.grantType === 'FreeChip') {
                          <div class="highlight">
                            <div class="game-img">
                              <img [src]="item.gameLogoUrl" (error)="item.gameLogoUrl = miniGameService.defaultImg" />
                            </div>
                            <div class="game-name">{{ item.gameName }}</div>
                          </div>

                          <div class="bonus-details">
                            <div class="item-detail">
                              <div class="label"><span>Ends on</span></div>
                              <div class="text">
                                @if (item.expiredTime === 0) {
                                  Permanent Valid
                                } @else {
                                  {{ item.expiredTime | mdate: 'DD/MM/YYYY HH:mm' }}
                                }
                              </div>
                            </div>
                            @if (item.grantType === 'FreeSpin') {
                              <div class="item-detail">
                                <div class="label"><span>Free spins</span></div>
                                <div class="text">{{ item.spinNum }}</div>
                              </div>
                              <div class="item-detail">
                                <div class="label"><span>Spin value</span></div>
                                <div class="text">
                                  {{
                                    item.amount
                                      | currencyValue: item.currency || ''
                                      | replace: ',' : ''
                                      | stripTrailingZeros
                                  }}
                                  {{ item.currency }}
                                </div>
                              </div>
                            } @else {
                              <div class="item-detail">
                                <div class="label"><span>Free chip worth</span></div>
                                <div class="text">
                                  {{
                                    item.amount
                                      | currencyValue: item.currency || ''
                                      | replace: ',' : ''
                                      | stripTrailingZeros
                                  }}
                                  {{ item.currency }}
                                </div>
                              </div>
                            }

                            @if (item.exchangeLimit && item.exchangeLimit > 0) {
                              <div class="item-detail">
                                <div class="label"><span>Max payout cap</span></div>
                                <div class="text">
                                  {{
                                    item.exchangeLimit
                                      | currencyValue: item.currency || ''
                                      | replace: ',' : ''
                                      | stripTrailingZeros
                                  }}
                                  {{ item.currency }}
                                </div>
                              </div>
                            }
                          </div>

                          <cs-button
                            label="Play Game"
                            color="primary"
                            size="default"
                            (buttonClick)="redirectToGame(item)"
                          ></cs-button>
                        }

                        @default {
                          @switch (true) {
                            @case (
                              item.walletType === NewBonusWalletType.FreeSpin ||
                              item.walletType === NewBonusWalletType.FreeChip
                            ) {
                              <div class="highlight">
                                <div class="tt">Winnings</div>
                                <div class="amount">
                                  <span>{{ item.amount | currencyValue: 'CNY' }}</span>
                                  <img class="currency-icon" [src]="item.currency | currencyIcon" alt="" />
                                </div>
                              </div>

                              <div class="bonus-details">
                                <div class="item-detail">
                                  <div class="label"><span>Ends on</span></div>
                                  <div class="text">
                                    @if (item.expiredTime === 0) {
                                      Permanent Valid
                                    } @else {
                                      {{ item.expiredTime | mdate: 'DD/MM/YYYY HH:mm' }}
                                    }
                                  </div>
                                </div>
                                <div class="item-detail">
                                  <div class="label"><span>Wagering requirement</span></div>
                                  <div class="text">{{ item.withdrawFlowMultiple }}x</div>
                                </div>
                              </div>

                              <cs-button
                                [label]="item.cardStatusDesc"
                                color="primary"
                                size="default"
                                [loading]="item.loading"
                                [disabled]="item.disabledBtn"
                                (buttonClick)="claimFreeBonus(item)"
                              ></cs-button>
                            }

                            @default {
                              <div class="highlight">
                                <div class="tt">
                                  You get {{ item.amount | currencyValue: 'CNY' }} {{ item.currency }}
                                </div>
                                <div class="amount">
                                  <span>{{ item.amount | currencyValue: 'CNY' }}</span>
                                  <img class="currency-icon" [src]="item.currency | currencyIcon" alt="" />
                                </div>
                              </div>

                              <div class="bonus-details">
                                <div class="item-detail">
                                  <div class="label">
                                    <span>Expires</span>
                                  </div>
                                  <div class="text">
                                    @if (item.expiredTime === 0) {
                                      No Expiry
                                    } @else {
                                      {{ item.expiredTime | mdate: 'DD/MM/YYYY HH:mm' }}
                                    }
                                  </div>
                                </div>
                              </div>

                              <cs-button
                                [label]="item.cardStatusDesc"
                                color="primary"
                                size="default"
                                [loading]="item.loading"
                                [disabled]="item.disabledBtn"
                                (buttonClick)="
                                  item.requiresCurrencyOnClaim ? handleOpenClaimBonusByCurrency(item) : claimBonus(item)
                                "
                              ></cs-button>
                            }
                          }
                        }
                      }
                    </div>
                  }
                </div>
                @if (eligibleBonusList.length === 0 && couponCardList.length === 0) {
                  <app-empty
                    [title]="'No eligible bonuses yet'"
                    [message]="'You don\'t have any bonuses available right now. Keep an eye on this page for new bonuses'"
                  ></app-empty>
                }
              }
            </div>
          </div>

          <!-- fag -->
          <div class="bonuses-wrap active">
            <div class="heading">
              <div><span>FAQ</span></div>
            </div>
            <div class="faq-box">
              @for (item of bonusFaqs; track $index) {
                <div class="faq-item" [class.active]="item.active" (click)="openQuestion($index)">
                  <div class="question">
                    <p>
                      {{ item.question }}
                    </p>
                    <cs-icon-button
                      iconType="icon"
                      [icon]="item.active ? 'fi-minus' : 'fi-plus'"
                      color="default"
                      size="12"
                    ></cs-icon-button>
                  </div>
                  <div class="answer">
                    <p>
                      {{ item.answer }}
                    </p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
